import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ClassificationCommonInfoResponse, IncidentSubtype, TypologyApiService} from '@npck/af-frontend-api';
import {rxSpinner} from '@npck/libs/commons';
import {toHTML} from 'ngx-editor';
import {AuthHolderService} from '../../../../../domain/auth-holder.service';

@Component({
    selector: 'af-classification-common-information-tab',
    standalone: false,
    templateUrl: './classification-common-information-tab.component.html',
    styleUrl: './classification-common-information-tab.component.scss',
})
export class ClassificationCommonInformationTabComponent implements OnInit {
    @Input() subtype: string;
    @Output() clickListener = new EventEmitter<void>();
    viewModel: ClassificationCommonInformationPanelViewModel[] = [];
    private fieldNames: (keyof ClassificationCommonInfoResponse)[] =
        ['description', 'implementationForm', 'implementationMethod', 'recommendations'];

    constructor(
        public authHolderService: AuthHolderService,
        private typologyApiService: TypologyApiService,
    ) {
    }

    ngOnInit(): void {
        this.typologyApiService.getClassificationCommonInfo(this.subtype as IncidentSubtype)
            .pipe(rxSpinner('commonClassification'))
            .subscribe(response => {
                if (response) {
                    this.viewModel = this.fieldNames
                        .map((key: keyof ClassificationCommonInfoResponse) => {
                            let value = response[key];
                            if (key === 'implementationMethod') {
                                value = toHTML(JSON.parse(value as string));
                            }
                            return <ClassificationCommonInformationPanelViewModel>{
                                name: key,
                                value: value,
                            };
                        });
                }
            });
    }
}

interface ClassificationCommonInformationPanelViewModel {
    name: string;
    value: string;
}
